<template>
    <div class="table-filter pt-4 pb-4" v-if="pageTypes">
        <div class="category-area tab-selector" v-if="pageTypes.length > 1">
            <span v-for="pageType in pageTypes"
                  class="category"
                  :class="{'selected' : selectedPageType && selectedPageType.type === pageType.type}"
                  @click="selectPageType(pageType)"
            >
                {{pageType.label}}
            </span>
        </div>
        <form method="POST" class="filter-input pt-4 pb-4" action="#" @submit.prevent="fetchPages()">
            <span class="filter">
                <input type="text" size="45" v-model="searchFilter" :placeholder="labelSearchTerms">
                <button type="submit" class="search-icon" @click="currentPage = 1">
                    <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1"
                         xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M13.8592 13.0189L14.7942 13.0189L20.7 18.9365L18.9365 20.7L13.0189 14.7942L13.0189 13.8592L12.6993 13.5278C11.3501 14.6877 9.59846 15.3859 7.69297 15.3859C3.44408 15.3859 0 11.9419 0 7.69297C0 3.44408 3.44408 0 7.69297 0C11.9419 0 15.3859 3.44408 15.3859 7.69297C15.3859 9.59846 14.6877 11.3501 13.5278 12.6993L13.8592 13.0189ZM2.36707 7.69297C2.36707 10.64 4.74597 13.0189 7.69297 13.0189C10.64 13.0189 13.0189 10.64 13.0189 7.69297C13.0189 4.74597 10.64 2.36707 7.69297 2.36707C4.74597 2.36707 2.36707 4.74597 2.36707 7.69297Z"
                              transform="translate(3.610547 3.6000001)" id="Shape" fill="#00358E" fill-rule="evenodd"
                              stroke="none"/>
                          <path d="M0 0L27.9 0L27.9 27.9L0 27.9L0 0Z" transform="translate(0.010546875 0)" id="Path"
                                fill="none" stroke="none"/>
                    </svg>
                </button>
                <button class="search-icon clear-search" @click="clearSearch()" v-if="searchFilter !== ''">
                    <i class="fa fa-eraser"></i>
                </button>
            </span>
        </form>
        <table v-if="selectedPageType && pages.length > 0 && !isChanging && (!isLoading || firstLoading)">
            <thead>
            <tr>
                <th>{{selectedPageType.label}}</th>
                <th class="date-order">{{labelDate}}</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(page, index) in pages"
                v-if="page"
                :class="{'odd-row' : (index % 2) === 0}"
            >
                <td>
                    <a :href="page.href">{{page.title}}</a>
                </td>
                <td>
                    {{renderDate(page.published_at)}}
                </td>
            </tr>
            </tbody>
        </table>


      <div class="row pt-5 pb-4" v-if="selectedPageType && pages.length === 0 && !isChanging">
        <strong class="d-block w-100 text-center">Sem resultados</strong>
      </div>

      <div v-if="isLoading || isChanging" class="text-center py-3">
        <loading-feedback :active="isLoading"></loading-feedback>
      </div>

      <div class="row pt-5 pb-4" v-if="selectedPageType && currentPage < (totalPages / max) && !isChanging && !isLoading">
        <a @click="getNewPage" class="btn btn-primary d-inline-block m-auto">{{$lang.get('pagination.loadmore')}}</a>
      </div>

      <!--<div class="pagination-pages pt-4 pb-4">
            <span v-if="currentPage>1" class="pagination-arrow previousPage" @click="goToPrev"></span>
            <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1"
                  @click="goToPage(page+1)"
                  v-for="page in paginationPages[0]"
                  class="selectPage"
                  :class="{'selected' : currentPage === page+1}">
            </span>
            <span v-if="paginationPages[1] !== undefined && currentPage > 5">...</span>
            <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1"
                  @click="goToPage(page+1)"
                  v-if="paginationPages[1] !== undefined"
                  v-for="page in paginationPages[1]"
                  class="selectPage"
                  :class="{'selected' : currentPage === page+1}">
            </span>
            <span v-if="paginationPages[1] !== undefined && currentPage < totalPages-4">...</span>
            <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1"
                  @click="goToPage(page+1)"
                  v-if="paginationPages[2] !== undefined"
                  v-for="page in paginationPages[2]"
                  class="selectPage"
                  :class="{'selected' : currentPage === page+1}">
            </span>
            <span v-if="currentPage<totalPages" class="pagination-arrow nextPage" @click="goToNext"></span>
        </div>-->
    </div>
</template>

<script>
    import Content from "../services/Content";
    import {DateTime} from "luxon";

    export default {
        props: [
            'pageTypes',
            'max',
            'sortDirection',
            'labelSearchTerms',
            'labelDate',
            'locale',
        ],

        data: () => {
            return {
                pages: [],
                selectedPageType: null,
                currentPage: 1,
                totalPages: 1,
                searchFilter: '',
                isLoading: false,
                firstLoading: true,
                isChanging: false,
                hash: '',
            }
        },

        mounted: function () {
          if (location.hash !== undefined) {

            this.hash = this.normalizeString(location.hash);
            let selected = this.pageTypes[0];
            Object.values(this.pageTypes).forEach(function (item) {
              let label = this.normalizeString(item.label);
              if (label === this.hash) {
                selected = item;
              }
            }.bind(this));
            this.selectPageType(selected);

          } else {
            this.selectPageType(this.pageTypes[0]);
          }
        },

        computed:{
            paginationPages:function(){
                let chunks = [];
                chunks[0] = [];
                chunks[1] = [];
                chunks[2] = [];
                chunks[0].push(0,1,2);
                if(this.totalPages <= 3){
                    chunks[1] = undefined;
                    chunks[2] = undefined;
                    chunks[0] = [];
                    for(let i = 0; i <= this.totalPages-1; i++)
                        if(i<this.totalPages-1)
                            chunks[0].push(i)
                }else if(this.totalPages <=5){
                    chunks[1] = undefined;
                    for(let i = 3; i<= this.totalPages-1; i++)
                        chunks[2].push(i);
                }else{
                    chunks[2].push(this.totalPages-3, this.totalPages-2, this.totalPages-1);
                    if(this.currentPage-1 > 1 && this.currentPage-1 < this.totalPages-3)
                        for(let i = this.currentPage -2; i<= this.currentPage; i++)
                            if(i > 2 && i < this.totalPages-3)
                                chunks[1].push(i)
                }
                return chunks;
            }
        },

        methods: {
            normalizeString: function (string) {
              return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
                  .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
                  .replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
                  .replace(/\s+/g, '-')	// Replaces space to one hyphen
                  .replace(/(^-+|-+$)/, '');
            },

            selectPageType: function (pageType) {
                this.selectedPageType = pageType;
                this.currentPage = 1;
                this.searchFilter = '';
                this.isChanging = true;
                this.fetchPages();
            },

            fetchPages: function (add = false) {
                this.isLoading = true;

                Content.FetchAllWithType(this.selectedPageType.type, this.currentPage, this.searchFilter, this.max, this.sortDirection, this.locale)
                    .then((res) => {
                        this.firstLoading= false;
                        this.isLoading = false;
                        this.isChanging = false;
                        this.totalPages = res.meta.pagination.total;

                        if (add) {
                          this.pages = this.pages.concat(res.data);
                        } else {
                          this.pages = res.data;
                        }
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
            },

            goToPrev: function () {
                if (--this.currentPage < 1) {
                    this.currentPage = 1;
                }

                this.fetchPages();
            },

            goToNext: function () {
                if (++this.currentPage > this.totalPages) {
                    this.currentPage = this.totalPages;
                }

                this.fetchPages();
            },

            goToPage: function(page){
                this.currentPage = page;
                this.fetchPages();
            },

            renderDate: (date) => {
                if (!date) {
                    return '';
                }

                return DateTime
                    .fromFormat(date, 'yyyy-MM-dd HH:mm:ss')
                    .toFormat('dd/MM/yyyy')
            },

            getNewPage: function () {
              this.currentPage += 1;
              this.firstLoading = true;
              this.fetchPages(true);
            },

            clearSearch: function () {
                this.searchFilter = '';
                this.fetchPages();
            }
        },
    }
</script>
